import * as React from 'react';
import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import fr from 'date-fns/locale/fr';
import { DesktopDatePicker, LocalizationProvider } from '@mui/lab';

interface DatePickerCustomProps {
    onDateChange: Function;
    value: Date | undefined;
    enabled: boolean;
}

export function CustomDatePicker({
    onDateChange,
    value,
    enabled
}: DatePickerCustomProps): JSX.Element {
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} locale={fr}>
            <DesktopDatePicker
                minDate={new Date()}
                disabled={!enabled}
                inputFormat="dd/MM/yyyy"
                value={value}
                onChange={(newValue: Date | null): void => onDateChange(newValue)}
                renderInput={(params): React.ReactElement => <TextField {...params} />}
            />
        </LocalizationProvider>
    );
}
